import { render, staticRenderFns } from "./gateDialog.vue?vue&type=template&id=6f5569a2&scoped=true"
import script from "./gateDialog.vue?vue&type=script&lang=ts"
export * from "./gateDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5569a2",
  null
  
)

export default component.exports